'use strict';

HolidaysService.$inject = ['mx.SolutionBuilderAgent.Http'];
export default function HolidaysService(http) {
	return {
		getUserHolidays: getUserHolidays,
	};

	function getUserHolidays(startDate, endDate) {
		var holidaysPromise = http.get('api/userinfo/holidays?startDate=' + startDate + '&endDate=' + endDate);

		holidaysPromise = holidaysPromise.then(function (data) {
			return data.map(function (item) {
				return {
					id: item.Id,
					name: item.Name,
					dateFrom: item.DateFrom,
					dateTo: item.DateTo,
					fullDay: item.FullDay,
					calendarEntryType: item.CalendarEntryType,
					calendarEntryTypeName: item.CalendarEntryTypeName,
					country: item.Country,
					countryName: item.CountryName,
				};
			});
		});

		return holidaysPromise;
	}
}
